export default __webpack_public_path__ + "static/media/permissions.9c2306f1.svg";